"use strict";

exports.__esModule = true;
exports.RightToolbarContent = exports.LeftToolbarContent = void 0;
exports.Toolbar = Toolbar;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _Theme = require("../../Theme");
var _excluded = ["children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var ToolbarWrapper = _styledComponents["default"].div.attrs({
  className: "toolbar"
}).withConfig({
  displayName: "Toolbar__ToolbarWrapper",
  componentId: "sc-x482pu-0"
})(["display:flex;flex:0 0 48px;height:48px;color:", ";background:", ";align-items:center;border-bottom:solid 1px ", ";padding:0.5rem 1rem;.", "{flex:1;}"], (0, _Theme.val)("ToolbarTextColor"), (0, _Theme.val)("ToolbarBackground"), (0, _Theme.val)("toolbarBorderColor"), _core.Classes.CONTROL_GROUP);
var LeftToolbarContent = exports.LeftToolbarContent = _styledComponents["default"].div.withConfig({
  displayName: "Toolbar__LeftToolbarContent",
  componentId: "sc-x482pu-1"
})(["display:flex;flex-direction:row;justify-content:flex-start;flex:1;"]);
var RightToolbarContent = exports.RightToolbarContent = _styledComponents["default"].div.withConfig({
  displayName: "Toolbar__RightToolbarContent",
  componentId: "sc-x482pu-2"
})(["display:flex;flex-direction:row;justify-content:flex-end;flex:1;"]);

/**
 * Displays Toolbar.
 */
function Toolbar(_ref) {
  var children = _ref.children,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(ToolbarWrapper, extra, children);
}